import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { api } from "utils/hostname";
import { currentCurrency } from "redux/user/selectors";
import { ExpSettings } from "types/ExpSettings";
import url from "../url";

export const useGetExpSettingCurrency = () => {
  const currency = useSelector(currentCurrency);

  const { data } = useQuery({
    queryKey: ["exp-setting"],
    queryFn: () =>
      api(true, true).get<{ data: ExpSettings[] }>(
        url.config.api.loyalty.expSetting,
        {
          params: { currencies: currency },
        },
      ),
    staleTime: Infinity,
  });

  return {
    currency,
    exps: data?.data?.data || [],
    exp: data?.data?.data?.sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    )[0],
  };
};
